<template>
    <div>
        <!-- <button @click="handleClick"> get </button> -->
        <svg width="100%" height="800" id="svg" style="border:1px solid red;background:#2D3039">
        </svg>
    </div>
</template>
<script>
import tflow from "@/assets/tflow/index"
import booldRender from "@/components/DataFlow/groupRender/bloodRender"
import "@/components/DataFlow/groupRender/bloodRender.css"
import "@/assets/tflow/style/tflow.css"
import groups from "./groups.json"
import links from "./links.json"
export default {
    name: "Test",
    data(){
        return {
            tableLinks:[]
        }
       
    },
    mounted() {
        // 注册 组 的渲染器
        tflow.groupRenderRegister("blood", booldRender)
        let config = {
            groupRender: "table", // 使用渲染器
            zoom:false,  // 是否缩放平移
            // 连线中回调函数
            onlinkconnecting: function (el,linkData) {
                let lineColor = "#258FFF"
                if(linkData.tag == "blood"){
                     lineColor = "#FFFFFF";
                }
                let c = el.select(".tflow-connection").attr({ stroke: lineColor })
                el.select(".tflow-connection-edge").attr({ stroke: "#222237" })
                el.select(".arrow").attr({ stroke: lineColor })
                let { x, y } = Snap.path.getPointAtLength(c.attr().d, 0)
                let circle = el.select("circle")
                if (circle) {
                    circle.attr({
                        cx: x, cy: y, r: 4
                    })
                }
            },
            // 连线完成回调函数
            onlinkconnected: function (el,linkData) {
                let lineColor = "#258FFF"
                if(linkData.tag == "blood"){
                     lineColor = "#FFFFFF";
                }
                let c = el.select(".tflow-connection").attr({ stroke: lineColor })
                let { x, y } = Snap.path.getPointAtLength(c.attr().d, 0)
                el.circle(x, y, 4).attr({
                    fill: lineColor,
                })
                el.select(".tflow-connection-edge").attr({ stroke: "#222237" })
                el.select(".arrow").attr({ stroke: lineColor })
                                
                
            },
            // 点击字段事件
            onclickField:(node,nodeId,active)=>{
                if(!active){
                    let relativeLinks=[]
                    let unrelativeLinks = this.filterLinksFromTables()
                    // this.flow.reRenderLinks(this.filterLinksFromTables())
                    return {relativeLinks,unrelativeLinks};
                }
                return this.filterLinksByNodeid(nodeId)
                
            },
            // 连线配置
            connectionConfig:{
                radius:10  // 圆角
            }
        }
        // 默认筛选出 表关联的links
        this.tableLinks = this.filterLinksFromTables();

        // 返回实例
        this.flow =tflow.init("#svg", groups,  this.tableLinks, config) // 初始化，将参数传入
            .layout({type:"default",hGap:300,vGap:160,vRandom:30}) // 自动布局算法 
            .render();   // 渲染

    },
    methods: {
        handleClick() {
            let g = this.flow.getGroupsData();
            let l = this.flow.getLinksData();
            console.log(JSON.stringify(g), JSON.stringify(l));
        },
        // 将字段血缘的连线筛选出来，再加上与这些无关的表级连线
        filterLinksByNodeid(nodeId){
            // 把target为nodeId的link找出来 递归
             function getLinkByR(data,targetid,result){
                 if(typeof targetid != 'object'){
                     targetid = [targetid]
                 }
                 
                 result = result || [];
                let res= data.filter(v=> targetid.includes(v.target.nodeId))
                if(res.length<1) return result;
                let nextTargetId = res.map(v=>v.source.nodeId)
                result.push(...res);
                return getLinkByR(data,nextTargetId,result)
             }

             let relativeLinks = getLinkByR(links,nodeId)
             // 把不牵涉到的link 找出来
             const isCover = link=>relativeLinks.every(v=>v.source.groupId != link.source.groupId || v.target.groupId != link.target.groupId)
             let unrelativeLinks  = _.cloneDeep(this.tableLinks).filter(isCover)
             let result = [...relativeLinks,...unrelativeLinks]
             return {relativeLinks,unrelativeLinks}
        },
        // 过滤出 表级别的连线
        filterLinksFromTables(){
            let nodeIds = groups.reduce((a,b)=>{a.push(...b.nodes); return a},[]).filter(nodes=>nodes.category == "table").map(v=>v.id)
            return links.filter(v=>nodeIds.includes(v.source.nodeId) || nodeIds.includes(v.target.nodeId) )
        }
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/Test/test.vue